 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED1 from '@/components/Untitled-1'
 import UNTITLED322 from '@/components/Untitled-3-22'
 import UNTITLED323 from '@/components/Untitled-3-23'
 import UNTITLED324 from '@/components/Untitled-3-24'
 import UNTITLED325 from '@/components/Untitled-3-25'
 import UNTITLED326 from '@/components/Untitled-3-26'
 import UNTITLED327 from '@/components/Untitled-3-27'
 import UNTITLED328 from '@/components/Untitled-3-28'
 import UNTITLED329 from '@/components/Untitled-3-29'
 import UNTITLED330 from '@/components/Untitled-3-30'
 import UNTITLED331 from '@/components/Untitled-3-31'
 import UNTITLED332 from '@/components/Untitled-3-32'
 import UNTITLED333 from '@/components/Untitled-3-33'
 import UNTITLED334 from '@/components/Untitled-3-34'
 import UNTITLED335 from '@/components/Untitled-3-35'
 import UNTITLED336 from '@/components/Untitled-3-36'
 import UNTITLED337 from '@/components/Untitled-3-37'
 import UNTITLED338 from '@/components/Untitled-3-38'
 import UNTITLED339 from '@/components/Untitled-3-39'
 import UNTITLED340 from '@/components/Untitled-3-40'
 import UNTITLED341 from '@/components/Untitled-3-41'
 import UNTITLED342 from '@/components/Untitled-3-42'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import BACKAD_1 from '@/components/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled-1",
 			"name" : "Untitled-1",
 			"component" : UNTITLED1
 		},
 		{
 			"path" : "/Untitled-3-22",
 			"name" : "Untitled-3-22",
 			"component" : UNTITLED322
 		},
 		{
 			"path" : "/Untitled-3-23",
 			"name" : "Untitled-3-23",
 			"component" : UNTITLED323
 		},
 		{
 			"path" : "/Untitled-3-24",
 			"name" : "Untitled-3-24",
 			"component" : UNTITLED324
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js